import { DisplayObject } from 'pixijs/display';

import type { CanvasRenderer } from 'pixijs/renderer/canvas';

/**
 * Renders the object using the Canvas renderer
 * @method renderCanvas
 * @memberof PIXI.Container#
 * @param {PIXI.CanvasRenderer} _renderer - The renderer
 */
DisplayObject.prototype.renderCanvas = function renderCanvas(_renderer: CanvasRenderer): void
{
    // OVERWRITE;
};
